export interface ContractError {
  code: string;
  message: string;
  severity: 'info' | 'warning' | 'error' | 'fatal';
  source: 'configurator' | 'player' | 'rules' | 'pricing' | 'api';
  retryable: boolean;
  requestId?: string;
  correlationId?: string;
  details?: Record<string, unknown>;
}

export const STALE_CONFIGURATION_REVISION: ContractError = {
  code: 'STALE_CONFIGURATION_REVISION',
  message: 'The configuration was updated from another source. Refresh and retry.',
  severity: 'warning',
  source: 'api',
  retryable: true,
};

export const CONFIGURATION_NOT_FOUND: ContractError = {
  code: 'CONFIGURATION_NOT_FOUND',
  message: 'Configuration session not found.',
  severity: 'error',
  source: 'api',
  retryable: false,
};

export const PRODUCT_NOT_FOUND: ContractError = {
  code: 'PRODUCT_NOT_FOUND',
  message: 'Product not found.',
  severity: 'error',
  source: 'api',
  retryable: false,
};
